import React from "react";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";

import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { InputSwitch } from "primereact/inputswitch";

import SubStationsInputs from "../SubStationsInputs";
import { TextEditor } from "../../../../components/TextEditor/TextEditor";
import { getImageUrl } from "../../../../utils/getImageUrl";

import * as styles from "../Stations.module.css";

function StationFormFields({
  control,
  isMulti,
  subStationInputs,
  minSubStationInputs,
  onChangeSubStationName,
  onChangeSubStationActive,
  onSelectSubStationImage,
  onAddSubStationInput,
  onRemoveSubStationInput,
}) {
  return (
    <>
      <Controller
        name="title"
        control={control}
        render={({ field }) => (
          <div className="field">
            <label>Title</label>
            <InputText
              className={`w-full mb-3 ${styles.input}`}
              placeholder="Title"
              {...field}
            />
          </div>
        )}
      />

      <Controller
        name="restriction"
        control={control}
        render={({ field }) => (
          <div className="field">
            <label>Order Frequency (minutes)</label>
            <InputMask
              mask="9?9"
              slotChar="  "
              className={`w-full mb-3 ${styles.input}`}
              {...field}
            />
          </div>
        )}
      />

      <Controller
        name="baseline_time"
        control={control}
        render={({ field }) => (
          <div className="field">
            <label>Baseline Time (minutes)</label>
            <InputMask
              mask="9?9"
              slotChar="  "
              className={`w-full mb-3 ${styles.input}`}
              {...field}
            />
          </div>
        )}
      />

      <div className="grid" style={{ gap: 8 }}>
        <div className="col-6">
          <Controller
            name="order_max_threshold"
            control={control}
            render={({ field }) => (
              <div className="field">
                <label>Max orders threshold</label>
                <InputText
                  type="number"
                  min={0}
                  max={65535}
                  className={`w-full ${styles.input}`}
                  placeholder="e.g. 50"
                  {...field}
                />
              </div>
            )}
          />
        </div>

        <div className="col-6">
          <Controller
            name="order_min_threshold"
            control={control}
            render={({ field }) => (
              <div className="field">
                <label>Min orders threshold</label>
                <InputText
                  type="number"
                  min={0}
                  max={65535}
                  className={`w-full ${styles.input}`}
                  placeholder="e.g. 10"
                  {...field}
                />
              </div>
            )}
          />
        </div>
      </div>

      <Controller
        name="midnight_autocomplete"
        control={control}
        render={({ field }) => (
          <div className={classNames("field", styles.autocompleteField)}>
            <label>Midnight Autocomplete</label>
            <InputSwitch
              checked={field.value}
              onChange={(e) => field.onChange(e.value)}
            />
          </div>
        )}
      />

      <Controller
        name="is_multi"
        control={control}
        render={({ field }) => (
          <div className={classNames("field", styles.autocompleteField)}>
            <label>Multi Station</label>
            <InputSwitch
              checked={field.value}
              onChange={(e) => field.onChange(e.value)}
            />
          </div>
        )}
      />

      {isMulti && (
        <SubStationsInputs
          subStationInputs={subStationInputs}
          minSubStationInputs={minSubStationInputs}
          onChangeSubStationName={onChangeSubStationName}
          onChangeSubStationActive={onChangeSubStationActive}
          onSelectSubStationImage={onSelectSubStationImage}
          onAddSubStationInput={onAddSubStationInput}
          onRemoveSubStationInput={onRemoveSubStationInput}
          getImageUrl={getImageUrl}
        />
      )}

      <Controller
        name="info"
        control={control}
        render={({ field }) => (
          <div className="field">
            <label>Info</label>
            <TextEditor
              value={field.value}
              onTextChange={(e) => field.onChange(e.htmlValue)}
            />
          </div>
        )}
      />
    </>
  );
}

export default StationFormFields;
